export interface SpotlightSaleBannerProps {
  variant: 'product' | 'serps';
  saving?: number;
}

const SpotlightSaleBanner = ({ saving, variant }: SpotlightSaleBannerProps) => {
  const BannerCopy = ({ saving, variant }: SpotlightSaleBannerProps) => {
    switch (variant) {
      case 'product':
        return (
          <>
            <span className="ch-color--ac-yellow">
              Save{saving ? ` £${saving}` : ''}
            </span>{' '}
            on this car.
          </>
        );

      case 'serps':
      default:
        return (
          <>
            Savings you don&apos;t{' '}
            <span className="ch-display--block sl:ch-display--inline-block">
              want to miss!
            </span>
          </>
        );
    }
  };

  return (
    <>
      <div className="ac-promo spotlight-promo ch-justify-content--between ch-align-items--start">
        <div className="ch-color--white ch-fw--500 ch-fs--3 sm:ch-fs--4 md:ch-fs--5">
          <BannerCopy saving={saving} variant={variant} />
        </div>
        <img
          alt="Spotlight car"
          className={`ac-promo__image ac-promo__image--${
            saving ? 'product' : 'serps'
          } ch-ml--2`}
          height="30"
          width={saving ? '97' : '130'}
        />
      </div>
    </>
  );
};

export default SpotlightSaleBanner;
